import { useState } from "react";

/**
 * Which record a list's dialog shows, and a key that changes on every open.
 *
 * The dialogs used to be keyed by the record's id alone, so reopening the same
 * record reused the mounted form: unsaved edits from a cancelled session came
 * back, and values saved meanwhile did not. Remounting on each open gives the
 * form fresh initial values from the row that was just clicked.
 */
export function useRecordDialog<T>() {
    const [state, setState] = useState<{ record: T | null; opened: boolean; seq: number }>({
        record: null,
        opened: false,
        seq: 0,
    });
    return {
        record: state.record,
        opened: state.opened,
        key: state.seq,
        open: (record: T | null) => setState((s) => ({ record, opened: true, seq: s.seq + 1 })),
        close: () => setState((s) => ({ ...s, opened: false })),
    };
}
